/*global ymaps:true*/
import React from 'react'
import {lifecycle} from 'recompose'
import MaptipCloseImg from '../../static/ballon-close.png'
import _ from 'lodash'

let myMap;

const Map = ({objects, mapLoadingFailed}) => (
  <div id="repmap" style={{width: '100%', height: 600,}}/>
)

export default lifecycle({
  componentDidMount() {
    const self = this;
    prepareScriptTag(this.props.currentLanguage)
      .then(() => {
        if (_.has(window, 'ymaps')) {
          ymaps.ready(() => {
            init(this.props.currentLanguage).then(() => {
              setPlacemarks(this.props.objects, this.props.pin, this.props.pinActive)
            }).catch(function (res) {
              console.log(res)
              self.props.setMapLoadingFailed(true)
            })
          })
        }
      });
  },
  componentDidUpdate(prevProps) {
    if (this.props.objects !== prevProps.objects) {
      myMap.geoObjects.removeAll()
      setPlacemarks(this.props.objects, this.props.pin, this.props.pinActive)
    }
  }
})(Map)

const prepareScriptTag = language => {
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://api-maps.yandex.ru/2.1/?lang=${language === 'en' ? 'en_US' : 'ru_RU'}`;
    document.head.appendChild(script);
    script.onload = () => resolve();
  });
}

const getCenterByLanguage = language => {
  switch (language) {
    case 'ru':
      return [55.92014738718691, 38.929466046875014];
    case 'ua':
      return [48.889102944710906, 31.182369999999924];
    case 'en':
      return [50.080293, 14.428983];
    default:
      return [55.92014738718691, 38.929466046875014];
  }
};

function init(language) {
  return new Promise(function (resolve, reject) {
    myMap = new ymaps.Map("repmap", {
      center: getCenterByLanguage(language),
      zoom: 5,
      controls: ['zoomControl', 'searchControl']
    })
    resolve(myMap)
  })
}

function setPlacemarks(objects, pin, pinActive) {
  for (let i = 0; i < objects.length; i++) {
    if (!objects[i].attribute.coords) {
      continue;
    }

    const placemark = createPlacemark(
      objects[i].attribute.coords.split(','),
      objects[i].name,
      objects[i].attribute.address,
      objects[i].attribute.phone,
      objects[i].attribute.email,
      objects[i].attribute.skype,
      objects[i].attribute.site,
      pin
    )

    placemark.events.add('balloonopen', (e) => {
      e.originalEvent.currentTarget.options.set('iconImageHref', pinActive)
    })
    placemark.events.add('balloonclose', function (e) {
      e.originalEvent.currentTarget.options.set('iconImageHref', pin)
    })
    myMap.geoObjects.add(placemark)
  }
}

function createPlacemark(coords, name, address, phone, email, skype, site, pin) {
  if (site && site.length > 0 && !site.includes('http:/') && !site.includes('https:/')) {
    site = 'http://' + site
  }

  const MyBalloonLayout = ymaps.templateLayoutFactory.createClass(`
    <div
      style="position: relative;
             background: white;
             width: 280px;
             overflow: hidden;
             padding: 26px 27px; 
             box-shadow: 0.2em 0.2em 0.8em 0.2em grey;"
    >
      <a
        href="javascript:void(0)"
        id="map-balloon-close"
        style="position: absolute; top: 5px; right: 5px; width: 21px; height: 21px; background: url(${MaptipCloseImg});"
       ></a>
      $[[options.contentLayout observeSize minWidth=230 maxWidth=230 ]]
    </div>
  `, {
      build: function () {
        this.constructor.superclass.build.call(this)
        const closeButton = document.getElementById("map-balloon-close")
        const self = this
        closeButton.onclick = function (e) {
          e.preventDefault()
          self.events.fire('userclose')
        }
      }
    }
  )

  const html = `
    <h3>${name}</h3>
    <p>${address}</p>
    <br/>
    ${phone ? `<p>${phone}</p>` : ''}
    ${email ? `<p>${email}</p>` : ''}
    ${skype ? `<p>${skype}</p>` : ''}
    ${site ? `<p><a target="_blank" href="${site}">${site}</a></p>` : ''}
  `

  const MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(html)
  const asPanel = window.innerWidth > 600 ? 0 : 'Infinity'

  return new ymaps.Placemark(coords, {
    balloonHeader: name,
    balloonAddress: address,
    balloonSite: site,
    balloonPhone: phone,
    balloonEmail: email,
    balloonSkype: skype
  }, {
    iconLayout: 'default#image',
    iconImageHref: pin,
    iconImageSize: [27, 40],
    iconImageOffset: [-13, -34],
    balloonShadow: false,
    balloonLayout: MyBalloonLayout,
    balloonContentLayout: MyBalloonContentLayout,
    balloonPanelMaxMapArea: asPanel,
    hideIconOnBalloonOpen: false,
  })
}



// WEBPACK FOOTER //
// ./src/finwhale/yandex-map/index.js